import "@tento-ui/components/prompt";

import { LonaWebComponent, html } from "@tento-ui/component";
import { CuratedWashes } from "@tento-ui/brand/landing/curated-washes";
import { GradientSplatWash } from "@tento-ui/brand/landing/gradient-splat-wash";
import { component } from "@tento-ui/component-decorators";
import { css, Style } from "@tento-ui/component-styles";
import { Prompt } from "@tento-ui/components/prompt";
import { Overlay } from "@tento-ui/components/overlay";
import { Round } from "@tento-ui/components/round";

@component({
  name: "lona-garmin-success",
})
export class GarminSuccessPage extends LonaWebComponent {
  $root = this.hydrate<Prompt>("root");
  private $bg: Round = this.hydrate("bg");
  private $wash: GradientSplatWash = this.hydrate("wash");
  onSubmit: Option<EmptyFunction>;

  constructor() {
    super();
    this.bindImageFrame("meadow-1");
    this.$root.bind({
      title: "Successfully Connected",
      description: "Your Garmin account has been linked to Lona",
      onSubmit: () => this.onSubmit?.(),
    });
  }

  static reveal(
    onSubmit: () => void,
    $overlay: Overlay = Overlay.instance.get(),
  ) {
    const $e = GarminSuccessPage.make();
    $e.onSubmit = () => {
      onSubmit();
      $overlay.dismiss($e);
    };
    $overlay.reveal($e);
    return $overlay;
  }

  private bindImageFrame(washId: string): void {
    this.$bg.bind({
      bg: "color-mix(in srgb, var(--bg) 88%, var(--text-pri) 12%)",
      continuous: { smoothing: 0.6 },
      radius: 24,
      shadow: false,
      clip: true,
    });
    this.$wash.bind({ wash: washId });
    this.$bg.style.setProperty(
      "--nux-image-soft-bg",
      CuratedWashes.byIdOr(washId, CuratedWashes.ALL[0]).softBackground,
    );
  }

  static $styles: Style.Compat[] = [
    css`
      /* Overlay reveals this host at full viewport width; the prompt
       * (max-width: 360px) doesn't self-center, so the host must. */
      :host {
        display: flex;
        justify-content: center;
      }

      #image-frame {
        position: relative;
        display: grid;
        place-items: center;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
      }

      #bg {
        display: grid;
        place-items: center;
        width: 100%;
        height: 100%;
      }

      #soft-bg {
        position: absolute;
        inset: 0;
        background: var(--nux-image-soft-bg);
        opacity: 0.18;
      }

      #wash {
        position: absolute;
        inset: 0;
        opacity: 0.2;
      }

      std-presentation-asset {
        position: relative;
        z-index: 1;
        width: 100%;
        height: 100%;
      }
    `,
  ];

  static $html: Option<HTMLTemplateElement> = html`
    <std-prompt id=root>
      <div id=image-frame slot=image>
        <std-round id=bg clip>
          <div id=soft-bg></div>
          <std-gradient-splat-wash id=wash></std-gradient-splat-wash>
          <std-presentation-asset
            src="lona-garmin-success"
            decorative
          ></std-presentation-asset>
        </std-round>
      </div>
    </std-prompt>
  `;
}
